import { ShieldCheck, Certificate, Target, FirstAid, Buildings } from "@phosphor-icons/react";
import RedCrossBadge from "@/components/RedCrossBadge";

const GROUPS = [
  {
    icon: Target,
    title: "Firearms Instruction",
    items: [
      "MD State Police HQL Certified Instructor",
      "D.C. Firearms Instructor Certified",
      "Utah Firearms Instructor Certified",
      "NRA Certified Instructor",
      "NRA Range Safety Officer",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Law Enforcement & Security",
    items: [
      "MD Special Police · Active",
      "Sabre Red OC Instructor",
      "ASP Baton · Handcuffs · Flashlight Instructor",
    ],
  },
  {
    icon: Buildings,
    title: "Partnerships & Business",
    items: [
      "U.S. LawShield® Training Partner",
      "Insured & Bonded",
      "Maryland Lic. · Multi-State Authorized",
    ],
  },
];

export default function TrustStrip({ code = "// 002 — CREDENTIALS · CERTIFICATIONS · LICENSING" }) {
  return (
    <section className="border-y border-white/10 bg-[#050505] section-pad" data-testid="trust-strip">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-8 mb-14 items-end">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-4">{code}</div>
            <h2 className="font-heading text-4xl md:text-6xl tracking-tighter leading-[0.95]">
              Licensed. Certified.<br/><span className="text-[#FFD300]">Accountable.</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5">
            <p className="text-neutral-400 leading-relaxed text-lg">
              Every credential our instructors hold is listed here — nothing implied, nothing inflated.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10">
          {GROUPS.map((g) => {
            const Icon = g.icon;
            return (
              <div key={g.title} className="bg-[#050505] p-8" data-testid={`credential-group-${g.title.replace(/[^a-z0-9]/gi, '-').toLowerCase()}`}>
                <Icon size={32} weight="thin" className="text-[#FFD300] mb-6" />
                <h3 className="font-heading text-xl tracking-tight mb-5">{g.title}</h3>
                <ul className="space-y-2.5" data-testid="trust-credentials">
                  {g.items.map((c) => (
                    <li key={c} className="flex items-start gap-2.5 text-sm text-neutral-300">
                      <Certificate size={14} weight="duotone" className="text-[#FFD300] mt-1 flex-shrink-0" />
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}

          <div className="bg-[#0A0A0A] p-8 border-l-2 border-[#ED1B2E]" data-testid="credential-group-red-cross">
            <FirstAid size={32} weight="thin" className="text-[#ED1B2E] mb-6" />
            <h3 className="font-heading text-xl tracking-tight mb-5">Medical / First Response</h3>
            <RedCrossBadge size={64} className="mb-5" />
            <ul className="space-y-2.5">
              {["First Aid / CPR / AED — Adult & Pediatric", "Certifications issued through the American Red Cross", "Valid 2 years · Digital certificate"].map((c) => (
                <li key={c} className="flex items-start gap-2.5 text-sm text-neutral-300">
                  <Certificate size={14} weight="duotone" className="text-[#ED1B2E] mt-1 flex-shrink-0" />
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
